"use client";

import { MainLink } from "@/components/shared/public";
import { useTranslations } from "next-intl";
import Image from "next/image";
import { notFound } from "../../../../public/images/backgrounds";

export default function NotFound() {
  const t = useTranslations("notFound");
  return (
    <div className="text-ring flex min-h-[80vh] flex-col items-center justify-center gap-6 p-2 text-center">
      <p>{t("message")}</p>
      <p className="border-primary mx-auto w-fit border-b pb-3">
        <span className="font-bold">{t("room404")}</span>
        &nbsp;
        <span>{t("renovated")}</span>
      </p>
      <p>
        <span>{t("use")}</span>
        &nbsp;
        <span className="font-bold">{t("nextDoor")}</span>
      </p>
      <Image src={notFound} alt={t("imageAlt")} width={1100} />
      <MainLink href="/" title={t("backToHome")} />
    </div>
  );
}
